import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { paths } from 'src/constants';

const useMakePayment = (
  subscriptionId,
  subscriptionDuration,
  paymentLabel,
  subscriptionKey,
  promoCode
) => {
  const history = useHistory();
  return useCallback(
    (paymentProvider, paymentMethod) => {
      if (!subscriptionId || !subscriptionDuration) {
        console.warn('Missing subscriptionId or subscriptionDuration');
        return;
      }

      history.push(
        `${paths.SUBSCRIPTION_PAYMENT}?paymentProvider=${paymentProvider}`,
        {
          subscriptionData: {
            subscriptionId,
            subscriptionDuration,
            subscriptionKey,
            promoCode,
          },
          paymentMethod,
          paymentLabel,
        }
      );
    },
    [
      history,
      subscriptionId,
      subscriptionDuration,
      paymentLabel,
      subscriptionKey,
      promoCode,
    ]
  );
};

export default useMakePayment;
